import './BankList.scss'

function BankList({ showPopup, setShowPopup, selectedBank, setSelectedBank, bankList }) {
  const handleSelect = (bank) => {
    setSelectedBank(bank.shortName) // chọn tên viết tắt
    setShowPopup(false)
  }

  return (
    <>
      {/* Overlay */}
      {showPopup && (
        <div
          className="bank_selector_overlay"
          onClick={() => setShowPopup(false)}
        />
      )}

      {/* Popup */}
      <div className={`bank_selector_popup ${showPopup ? 'open' : ''}`}>
        <div className="bank_selector_header">
          <h3>เลือกธนาคาร</h3>
          <button className="close_btn" onClick={() => setShowPopup(false)}>✖</button>
        </div>

        <div className="bank_selector_list">
          {bankList.length === 0 ? (
            <p className="loading">กำลังโหลดธนาคาร…</p>
          ) : (
            bankList.map((bank) => (
              <div
                key={bank.code}
                className={`bank_selector_item ${selectedBank === bank.shortName ? 'active' : ''}`}
                onClick={() => handleSelect(bank)}
              >
                {/* <img
                  src={bank.logo || ''}
                  alt={bank.shortName}
                  className="bank_selector_logo"
                /> */}
                <span className="bank_selector_name">{bank.shortName}</span>
                {selectedBank === bank.shortName && (
                  <span className="bank_selector_check">✔</span>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </>
  )
}

export default BankList
